// src/pages/CommentManger/CommentManger.js
import React, { useEffect, useMemo, useState } from 'react';
import api from '../../../api';
import axios from 'axios';
import { formatKST } from '../../../util';
import styles from './CommentManager.module.css';

const REGIONS = [
  '공식',
  '서울','경기','대구','대전','광주',
  '부산','인천','제주','전북','전남',
  '울산','경북','경남','강원',
  '충북','충남','세종'
];
const REGION_OPTIONS = ['전지역', ...REGIONS];

const normalizeIgHandle = (u) => (u ?? '').toString().trim().replace(/^@+/, '').toLowerCase();

const REGION_HANDLE = {
  '서울': 'seoul_hotple_kr',
  '경기': 'gyeonggi_hotple_kr',
  '인천': 'incheon_hotple_kr',
  '대전': 'daejeon_hotple_kr_',
  '강원': 'gangwon_hotple_kr',
  '충북': 'chungbuk_hotple_kr',
  '충남': 'chungnam_hotple_kr_',
  '세종': 'sejong_hotple_kr',
  '부산': 'busan_hotple_kr',
  '대구': 'daegu_hotple_kr',
  '울산': 'ulsan_hotple_kr',
  '경북': 'gyeongbuk_hotple_kr',
  '경남': 'gyeongnam_hotple_kr_',
  '제주': 'jeju_hotple_kr_',
  '광주': 'gwangju_hotple_kr',
  '전북': 'jeonbuk_hotple_kr',
  '전남': 'jeonnam_hotple_kr',
  '공식': 'hotple_kr',
  '테스트': 'test_hp_kr',
};

function metricVal(m, name) {
  try {
    const it = m?.insights?.data?.find(x => x.name === name);
    return it?.total_value?.value ?? it?.values?.[0]?.value ?? 0;
  } catch { return 0; }
}

function countUnhandled(comments, handledSet, selfSet) {
  const walk = (arr = []) => arr.reduce((acc, c) => {
    const isSelf = c?.username && selfSet.has(String(c.username).toLowerCase());
    const mine = (handledSet.has(c.id) || isSelf) ? 0 : 1; // 본인 댓글 자동 처리
    const rep  = c.replies?.data?.length ? walk(c.replies.data) : 0;
    return acc + mine + rep;
  }, 0);
  return walk(comments);
}

const CommentRow = ({ region, c, caption, handledSet, selfSet, onReply, onConfirm, isReply=false }) => {
  const [open, setOpen] = useState(false);
  const [text, setText] = useState('');
  const [followPlan, setFollowPlan] = useState(false);
  const [genLoading, setGenLoading] = useState(false);
  const isSelf = c?.username && selfSet.has(String(c.username).toLowerCase());
  const handled = handledSet.has(c.id) || isSelf;
  const followRegions = Array.isArray(c?._follow_regions) ? c._follow_regions : [];
  const isFollowedHere = followRegions.includes(region);
  const otherRegions = followRegions.filter(r => r !== region);
  const shown = otherRegions.slice(0, 2); // 너무 길면 2개까지만
  const more  = otherRegions.length - shown.length;

  return (
    <div className={isReply ? styles.replyRow : styles.commentRow}>
      <div className={styles.rowTop}>
        <div className={styles.meta}>
          <span className={styles.username} onClick={()=>window.open(`https://instagram.com/${c.username}`,'_blank')}>@{c.username}</span>
          <span className={styles.dot}>·</span>
          <span>{formatKST(c.timestamp)}</span>
          {!!c.like_count && (<><span className={styles.dot}>·</span><span>♥ {c.like_count}</span></>)}
          {isFollowedHere && (
            <span className={styles.badgeFollowOwn}>팔로잉 중</span>
          )}
          {otherRegions.length > 0 && (
            <span className={styles.badgeFollowOther}>
              {shown.join(', ')}{more > 0 ? ` 외 ${more}개` : ''} 계정이 팔로잉 중
            </span>
          )}
          {handled && <span className={styles.badge}>처리됨</span>}
        </div>
        <div className={styles.actions}>
          {!handled && (
            <button className={styles.btnLight} onClick={() => onConfirm(region, c.media_id, c.id, c.username)}>확인</button>
          )}
          <button className={styles.btnOutline} onClick={() => setOpen(v => !v)}>답글</button>
        </div>
      </div>

      <div className={styles.text}>{c.text}</div>

      {open && (
        <div className={styles.replyBox}>
          <input
            className={styles.replyInput}
            value={text}
            onChange={(e)=>setText(e.target.value)}
            placeholder="답글 내용을 입력하세요"
          />
          <button
            className={styles.btnLight}
            disabled={genLoading}
            onClick={async () => {
              try {
                setGenLoading(true);

                const payload = {
                  account_region: region,
                  post_caption: caption || '',
                  original_comment: c.text,
                  commenter_username: normalizeIgHandle(c.username),
                  // is_followed_by_current_region 은 보내지 않음 → 서버가 DB에서 계산
                };

                const { data } = await axios.post(
                  'https://hotple.today/win-api/api/suggest-reply',
                  payload,
                  { timeout: 20000 }
                );

                setText(data?.text || '');
              } catch (e) {
                console.error(e);
                alert('답글 생성 실패');
              } finally {
                setGenLoading(false);
              }
            }}
          >
           {genLoading ? '생성중…' : '답글 생성'}
         </button>
          <label className={styles.followCheck}>
            <input
              type="checkbox"
              checked={followPlan}
              onChange={(e)=>setFollowPlan(e.target.checked)}
            />
            팔로우 예정
          </label>
          <button
            className={styles.btn}
            onClick={() => {
              if (!text.trim()) return;
              // username과 followPlan 함께 전달
              onReply(region, c.id, text.trim(), c.username, followPlan);
              setText('');
              setFollowPlan(false);
              setOpen(false);
            }}
          >전송</button>
        </div>
      )}

      {!!c.replies?.data?.length && (
        <div className={styles.replies}>
          {c.replies.data.map(r => (
            <CommentRow
              key={r.id}
              region={region}
              c={{ ...r, media_id: c.media_id }}
              handledSet={handledSet}
              selfSet={selfSet}
              onReply={onReply}
              onConfirm={onConfirm}
              isReply
            />
          ))}
        </div>
      )}
    </div>
  );
};

const CommentManager = ({setAdViseStep}) => {
  // ✅ 단일 선택
  const [selectedRegion, setSelectedRegion] = useState('전지역');

  const [mediaByRegion, setMediaByRegion] = useState({});     // { region: [media...] }
  const [handledByRegion, setHandledByRegion] = useState({}); // { region: Set(ids) }
  const [unreadOnly, setUnreadOnly] = useState(false);
  const [loading, setLoading] = useState(false);
  const [mediaComment, setMediaComment] = useState({}); // { [mediaId]: "text" }

  // 지역별 미확인 댓글 수 (본인 댓글 제외)
  const unhandledByRegion = useMemo(() => {
    const out = {};
    for (const r of REGIONS) {
      const handledSet = handledByRegion[r] ?? new Set();
      const selfSet = new Set([ (REGION_HANDLE[r] || '').toLowerCase() ]);
      const medias = mediaByRegion[r] ?? [];
      let sum = 0;
      medias.forEach(m => { sum += countUnhandled(m.comments, handledSet, selfSet); });
      out[r] = sum;
    }
    return out;
  }, [mediaByRegion, handledByRegion]);

  async function fetchAll() {
    setLoading(true);
    try {
      const regionsParam = REGIONS.join(',');
      const { data: byRegion } = await api.get('/advise/admin/media', { params: { regions: regionsParam } });
      const handledMap = {};
      for (const r of REGIONS) {
        const { data } = await api.get('/advise/admin/handled-comments', { params: { region: r }});
        handledMap[r] = new Set(data?.handledIds ?? []);
      }
      const normalized = {};
      for (const r of REGIONS) {
        const arr = (byRegion?.[r] ?? []).map(m => ({
          ...m,
          __open: false,
          comments: Array.isArray(m.comments?.data) ? m.comments.data.map(c => ({ ...c, media_id: m.id })) : [],
        }));
        normalized[r] = arr;
      }
      setMediaByRegion(normalized);
      setHandledByRegion(handledMap);
    } finally { setLoading(false); }
  }
  useEffect(() => { fetchAll(); }, []);

  const onCommentMedia = async (region, mediaId, message) => {
    try {
      await api.post(`/advise/admin/media/${encodeURIComponent(mediaId)}/comment`, { region, message });
      alert('댓글 전송 완료');
      // 필요하면 로컬 카운트만 살짝 올리기 (옵션)
      setMediaByRegion(prev => {
        const arr = (prev[region] ?? []).map(m => (
          m.id === mediaId
            ? { ...m, comments_count: (m.comments_count ?? m.comments?.length ?? 0) + 1 }
            : m
        ));
        return { ...prev, [region]: arr };
      });
    } catch (e) {
      console.error(e);
      alert('댓글 전송 실패');
    }
  };

  const onToggle = (region, mediaId) => {
    setMediaByRegion(prev => {
      const arr = prev[region] ?? [];
      return { ...prev, [region]: arr.map(m => m.id === mediaId ? { ...m, __open: !m.__open } : m) };
    });
  };

  const onReply = async (region, commentId, message, username, followPlan = false) => {
    try {
      await api.post(`/advise/admin/comments/${commentId}/reply`, {
        region,
        message,
        username,    // 댓글 작성자 핸들
        followPlan   // 팔로우 예정 여부
      });
      setHandledByRegion(prev => {
        const s = new Set(prev[region] ?? []);
        s.add(commentId);
        return { ...prev, [region]: s };
      });
      alert('답글 전송 완료');
    } catch (e) { console.error(e); alert('답글 전송 실패'); }
  };

  const onConfirm = async (region, mediaId, commentId, username) => {
    try {
      await api.post(`/advise/admin/comments/${commentId}/confirm`, { region, mediaId, username });
      setHandledByRegion(prev => {
        const s = new Set(prev[region] ?? []);
        s.add(commentId);
        return { ...prev, [region]: s };
      });
    } catch (e) { console.error(e); alert('확인 처리 실패'); }
  };

  // 상단 통계는 선택 지역에 따라 계산
  const visibleRegions = selectedRegion === '전지역' ? REGIONS : [selectedRegion];
  const topStats = useMemo(() => {
    let posts=0, comments=0, likes=0, reach=0, saves=0, shares=0;
    visibleRegions.forEach(r => {
      (mediaByRegion[r] ?? []).forEach(m => {
        posts += 1;
        comments += (m.comments_count ?? m.comments?.length ?? 0);
        likes += (m.like_count ?? 0);
        reach += metricVal(m, 'reach');
        saves += metricVal(m, 'saved');
        shares += metricVal(m, 'shares');
      });
    });
    return { posts, comments, likes, reach, saves, shares };
  }, [visibleRegions, mediaByRegion]);

  return (
    <div className={styles.page}>
      <div className={styles.header}>
        <img
          className={styles.backbuttonIcon}
          alt=""
          src="images/back_android.svg"
          onClick={() => setAdViseStep(0)}
        />
        <h2>인스타 댓글 관리</h2>
        <div className={styles.headerRight}>
          <button className={styles.btn} onClick={fetchAll} disabled={loading}>새로고침</button>
          <label className={styles.check}>
            <input type="checkbox" checked={unreadOnly} onChange={()=>setUnreadOnly(v=>!v)} />
            확인 안한 댓글만
          </label>
        </div>
      </div>

      <div className={styles.stats}>
        <div>선택 지역: {selectedRegion}</div>
        <div>게시글: {topStats.posts.toLocaleString()}개</div>
        <div>댓글: {topStats.comments.toLocaleString()}개</div>
        <div>좋아요: {topStats.likes.toLocaleString()}개</div>
        <div>도달합: {topStats.reach.toLocaleString()}</div>
        <div>저장: {topStats.saves.toLocaleString()}개</div>
        <div>공유: {topStats.shares.toLocaleString()}개</div>
      </div>

      {/* ✅ 단일 선택 필터 + 미확인 수 표시 */}
      <div className={styles.chips}>
        {REGION_OPTIONS.map(r => (
          <button
            key={r}
            className={selectedRegion === r ? styles.chipOn : styles.chipOff}
            onClick={() => setSelectedRegion(r)}
          >
            {r}{r !== '전지역' ? ` (${unhandledByRegion[r] ?? 0})` : ''}
          </button>
        ))}
      </div>

      {loading ? (
        <div className={styles.loading}>불러오는 중…</div>
      ) : (
        <div className={styles.regionList}>
          {visibleRegions.map(region => {
            const handledSet = handledByRegion[region] ?? new Set();
            const selfSet = new Set([ (REGION_HANDLE[region] || '').toLowerCase() ]);
            const medias = mediaByRegion[region] ?? [];

            return (
              <div key={region} className={styles.regionBlock}>
                <h3 className={styles.regionTitle}>
                  {region}{' '}
                  <span className={styles.muted}>
                    (미확인 {unhandledByRegion[region] ?? 0})
                  </span>
                </h3>

                {medias.map(m => {
                  const unhandled = countUnhandled(m.comments, handledSet, selfSet);
                  if (unreadOnly && unhandled <= 0) return null;

                  const reach = metricVal(m, 'reach');
                  const saves = metricVal(m, 'saved');
                  const shares= metricVal(m, 'shares');

                  return (
                    <div key={m.id} className={styles.card}>
                      {/* 닫힌 헤더 */}
                      <button className={styles.cardHeader} onClick={()=>onToggle(region, m.id)}>
                        <div className={styles.headerLeft}>
                          <div className={styles.pill}>{region}</div>
                          <div className={styles.time}>{formatKST(m.timestamp)}</div>
                          <a href={m.permalink} target="_blank" rel="noreferrer" className={styles.link}>게시글 ↗</a>
                        </div>
                        <div className={styles.headerRight}>
                          <span>댓 {m.comments_count ?? m.comments?.length ?? 0}</span>
                          <span className={styles.dot}>·</span>
                          <span>♥ {m.like_count ?? 0}</span>
                          <span className={styles.dot}>·</span>
                          <span>도달 {reach}</span>
                          <span className={styles.dot}>·</span>
                          <span>저장 {saves}</span>
                          <span className={styles.dot}>·</span>
                          <span>공유 {shares}</span>
                          {unhandled > 0 && <span className={styles.unread}>{unhandled}</span>}
                        </div>
                      </button>

                      {/* 열린 본문 */}
                      {m.__open && (
                        <div className={styles.cardBody}>
                          <div className={styles.caption}>{m.caption || '(캡션 없음)'}</div>

                          <div className={styles.replyBox}>
                            <input
                              className={styles.replyInput}
                              value={mediaComment[m.id] ?? ''}
                              onChange={(e)=>setMediaComment(prev => ({ ...prev, [m.id]: e.target.value }))}
                              placeholder="이 게시글에 댓글 달기…"
                            />
                            <button
                              className={styles.btn}
                              onClick={() => {
                                const text = (mediaComment[m.id] ?? '').trim();
                                if (!text) return;
                                onCommentMedia(region, m.id, text);
                                setMediaComment(prev => ({ ...prev, [m.id]: '' }));
                              }}
                            >
                              전송
                            </button>
                          </div>

                          <div className={styles.comments}>
                            {m.comments?.length ? m.comments.map(c => (
                              <CommentRow
                                key={c.id}
                                region={region}
                                c={{ ...c, media_id: m.id }}
                                caption={m.caption || ''}
                                handledSet={handledSet}
                                selfSet={selfSet}
                                onReply={onReply}
                                onConfirm={onConfirm}
                              />
                            )) : <div className={styles.empty}>댓글이 없습니다.</div>}
                          </div>
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default CommentManager;
